// ApplicationNotAccepted
import React from 'react';
import { AntiRabiesSession2026 } from '../views';

const ApplicationNotAcceptedPage = () => {
  return <AntiRabiesSession2026/>;
};

export default ApplicationNotAcceptedPage;